import {
  isKnownDirection,
  readDirection,
} from "./direction-display";

/**
 * A row is sign-complete when we can paint it without inventing a side
 * (and therefore a P&L sign): known long/short, positive size, and a symbol.
 * Incomplete rows must stay off the open book until a snapshot or delta
 * supplies those fields — partial rows were the inverted-P&L / vanish class.
 */
export function isSignCompletePosition(row: {
  direction?: unknown;
  side?: unknown;
  quantity?: unknown;
  volume?: unknown;
  open_volume?: unknown;
  instrument?: unknown;
  contract_symbol?: unknown;
  symbol?: unknown;
}): boolean {
  const direction = readDirection(row.direction ?? row.side);
  if (!isKnownDirection(direction)) return false;
  const qty = Number(row.quantity ?? row.volume ?? row.open_volume);
  if (!Number.isFinite(qty) || qty <= 0) return false;
  const symbol = String(
    row.instrument ?? row.contract_symbol ?? row.symbol ?? "",
  ).trim();
  return symbol.length > 0;
}

/**
 * Stable open-table key. Local DB ids change when a REST snapshot replaces a
 * WS-inserted row; broker_position_id does not. Keying on the local id made
 * a live row unmount (silent vanish) and remount later under a new id.
 */
export function openPositionRowKey(trade: {
  id?: unknown;
  tradeId?: unknown;
  accountId?: unknown;
  ticker?: unknown;
}): string {
  const brokerId =
    trade.tradeId != null && String(trade.tradeId).trim() !== ""
      ? String(trade.tradeId)
      : "";
  const account =
    trade.accountId != null && String(trade.accountId) !== "undefined"
      ? String(trade.accountId)
      : "";
  if (brokerId) return `bp:${account}:${brokerId}`;
  const local =
    trade.id != null && String(trade.id) !== "undefined" ? String(trade.id) : "";
  const ticker = trade.ticker != null ? String(trade.ticker) : "";
  return `loc:${account}:${ticker}:${local}`;
}
